import * as React from "react";
const SvgNotificationCheck = props => <svg xmlns="http://www.w3.org/2000/svg" width={10} height={8} fill="#008EF0" viewBox="0 0 10 8" {...props}><path fill="inherit" d="m0 4.32 3.424 3.43L10 1.181 9.056.25 3.424 5.875.931 3.382z" /></svg>;
export default SvgNotificationCheck;